import _classCallCheck from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import styled from 'styled-components';
import styles from './Alert.style';
import RichText from '../../atoms/RichText/RichText';
import { setSessionStorage, getSessionStorage } from '../../../utils/utilityFunction';
import Scheduler from '../../../HOC/schedulerHOC';
import Close from '../../../static/images/icons/Close';
import { parseRichText } from '../../../utils/utilityFunction';
var Alert = /*#__PURE__*/function (_Component) {
  _inherits(Alert, _Component);
  var _super = _createSuper(Alert);
  // Set default props

  function Alert(props) {
    var _this;
    _classCallCheck(this, Alert);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      alertOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "isShowAlert", function (alertSwitch) {
      var alertSwitchValue = alertSwitch && alertSwitch.toLowerCase() === 'on';
      return alertSwitchValue && !_this.sessionValue && _this.state.alertOpen;
    });
    _defineProperty(_assertThisInitialized(_this), "handleAlertClose", function () {
      _this.setState({
        alertOpen: false
      });
      setSessionStorage(_this.sessionFieldName, '1');
    });
    _this.sessionFieldName = 'alert-displayed';
    _this.sessionValue = getSessionStorage(_this.sessionFieldName);
    return _this;
  }
  _createClass(Alert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        alertOpen: !this.state.alertOpen
      });
    }
  }, {
    key: "triggerAnalytics",
    value: function triggerAnalytics(alertBody) {
      if (typeof window !== 'undefined' && window.dataLayer) {
        var htmlContent = parseRichText(alertBody);
        var content = htmlContent.replace(/<\/?[^>]+>/gi, ' ').trim();
        window.dataLayer.push({
          alertName: content,
          event: 'alert'
        });
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$alertData = this.props.alertData,
        alertMessage = _this$props$alertData.alertMessage,
        alertActive = _this$props$alertData.alertActive,
        alertStart = _this$props$alertData.alertStart,
        alertEnd = _this$props$alertData.alertEnd;
      var className = this.props.className;
      var alertMessageItem = alertMessage ? alertMessage.json : '';
      return this.isShowAlert(alertActive) && this.triggerAnalytics(alertMessageItem) ? __jsx(Scheduler, {
        startDate: alertStart,
        endDate: alertEnd
      }, __jsx("div", {
        className: "nva-alert ".concat(className)
      }, __jsx(Close, {
        className: "nva-alert__close-button close-button",
        onClick: this.handleAlertClose
      }), __jsx(RichText, {
        ContainerElem: "div",
        jsonContent: alertMessageItem,
        className: "nva-alert__message container"
      }))) : '';
    }
  }]);
  return Alert;
}(Component);
_defineProperty(Alert, "defaultProps", {
  className: ''
});
export default styled(Alert).withConfig({
  componentId: "sc-7evjw5-0"
})(["", ";"], styles);
export { Alert as AlertVanilla };